import Widgets from '@/widgets'


export default [
	{ name:'avatar', widget:Widgets.fileImage, attrs: { type:'file', required:true, placeholder:"Выберите изображение...", }, label:"" },
]
